<template>
	<h3 @click="showInspirationCenter" class="reg pointer">Inspiration Center</h3>
</template>
<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { setShowInspirationCenter } from '@/store/modules/appLayout/actions';
export default {
	name: 'OpenInspirationCenterButton',
	methods: {
		...mapActionsShorthand({ setShowInspirationCenter }),
		showInspirationCenter() {
			this.setShowInspirationCenter({ showInspirationCenter: true });
		},
	},
};
</script>
<style scoped lang="scss">
.pointer {
	cursor: pointer;
	color: #6762f0;
	text-decoration: underline;
}
</style>
